<div class="grd-drawer">

  <div class="grd-drawer__header">
    <span class="grd-drawer__title">{{ 'REMESAS.DETAIL.TITULO' | translate:{ tipo: tipologiaLabel() | lowercase } }}</span>
    <button type="button" class="grd-icon-btn" (click)="cancelar()" [attr.aria-label]="'COMMON.CLOSE' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="grd-drawer__body">

    <div class="grd-badges">
      <span class="grd-badge"
            [class.grd-badge--enviada]="isEnviada()"
            [class.grd-badge--borrador]="isBorrador()"
            [class.grd-badge--pendiente-firma]="isPendienteFirma()"
            [class.grd-badge--programada]="isProgramada()">
        <mat-icon *ngIf="isProgramada()">schedule</mat-icon>
        {{ estadoLabel() }}
      </span>
      <span class="grd-badge"
            [class.grd-badge--comunicacion]="esComunicacion()"
            [class.grd-badge--notificacion]="esNotificacion()">
        {{ tipologiaLabel() }}
      </span>
    </div>

    <h2 class="grd-asunto">{{ data.comunicacion.concepto }}</h2>

    <div class="grd-meta">
      <div *ngIf="data.comunicacion.fechaCreacion">
        <span class="grd-meta-label">{{ 'REMESAS.DETAIL.CREADA' | translate }}</span>
        <span>{{ formatFecha(data.comunicacion.fechaCreacion) }}</span>
      </div>
      <div *ngIf="isProgramada() && data.comunicacion.fechaProgramacion">
        <span class="grd-meta-label">{{ 'REMESAS.DETAIL.PROGRAMADA_PARA' | translate }}</span>
        <span>{{ formatFecha(data.comunicacion.fechaProgramacion) }}</span>
      </div>
      <div *ngIf="!isProgramada() && data.comunicacion.fechaEnvio">
        <span class="grd-meta-label">{{ 'REMESAS.DETAIL.ENVIADA' | translate }}</span>
        <span>{{ formatFecha(data.comunicacion.fechaEnvio) }}</span>
      </div>
      <div *ngIf="data.comunicacion.creadoPor as u">
        <span class="grd-meta-label">{{ 'REMESAS.DETAIL.CREADA_POR' | translate }}</span>
        <span>{{ nombreUsuario(u) }}</span>
      </div>
      <div *ngIf="isPendienteFirma() && !data.comunicacion.fechaFirma && data.comunicacion.firmadoPor as f">
        <span class="grd-meta-label">{{ 'REMESAS.DETAIL.FIRMA_SOLICITADA' | translate }}</span>
        <span>{{ nombreUsuario(f) }}</span>
      </div>
      <div *ngIf="data.comunicacion.fechaFirma && data.comunicacion.firmadoPor as f">
        <span class="grd-meta-label">{{ 'REMESAS.DETAIL.FIRMADA_POR' | translate }}</span>
        <span>{{ nombreUsuario(f) }} · {{ formatFecha(data.comunicacion.fechaFirma) }}</span>
      </div>
      <div *ngIf="data.comunicacion.enviadoPor as e">
        <span class="grd-meta-label">{{ 'REMESAS.DETAIL.ENVIADA_POR' | translate }}</span>
        <span>{{ nombreUsuario(e) }}</span>
      </div>
      <div *ngIf="data.comunicacion.procedimiento as p">
        <span class="grd-meta-label">{{ 'REMESAS.DETAIL.TRAMITE_SIA' | translate:{ sia: p.sia } }}</span>
        <span>{{ p.codigo ? '[' + p.codigo + '] ' : '' }}{{ p.nombre }}</span>
      </div>
    </div>

    <div class="grd-section-label">{{ 'REMESAS.DETAIL.CUERPO' | translate }}</div>
    <div class="grd-cuerpo">
      <p *ngIf="data.comunicacion.descripcion">{{ data.comunicacion.descripcion }}</p>
      <p *ngIf="!data.comunicacion.descripcion" class="grd-empty-text">{{ 'REMESAS.PREVIEW.SIN_CUERPO' | translate }}</p>
    </div>

    <div class="grd-section-label">
      {{ 'REMESAS.DETAIL.DESTINATARIOS' | translate:{ count: data.comunicacion.destinatarios.length } }}
    </div>
    <div class="grd-destinatarios">
      <div *ngFor="let d of data.comunicacion.destinatarios" class="grd-destinatario">
        <span class="grd-avatar">{{ iniciales(d) }}</span>
        <div class="grd-d-info">
          <div class="grd-d-name">
            {{ etiquetaDest(d) }}
          </div>
          <div class="grd-d-meta">
            {{ d.email }} <span *ngIf="d.numero_documento">· {{ d.numero_documento }}</span>
            <span *ngIf="d.identificador" class="grd-d-id">· {{ 'REMESAS.DETAIL.ID_NOTIFICA' | translate:{ id: d.identificador } }}</span>
            <span *ngIf="estadoEnvioLabel(d)" class="grd-d-estado"
                  [class.grd-d-estado--aceptada]="d.estadoEnvio === 'ACEPTADA'"
                  [class.grd-d-estado--rechazada]="d.estadoEnvio?.startsWith('RECHAZADA')">
              {{ estadoEnvioLabel(d) }}<ng-container *ngIf="d.fechaFirma"> · {{ formatFecha(d.fechaFirma) }}</ng-container>
            </span>
          </div>
        </div>
        <div class="grd-d-actions">
          <button type="button" class="grd-icon-btn" *ngIf="d.documento"
                  [disabled]="descargando"
                  (click)="descargar(d.documento, 'documento.pdf')"
                  [matTooltip]="'REMESAS.DETAIL.DESCARGAR_DOC' | translate"
                  matTooltipClass="em-tooltip"
                  matTooltipPosition="left" [attr.aria-label]="'REMESAS.DETAIL.DESCARGAR_DOC' | translate">
            <mat-icon>description</mat-icon>
          </button>
          <button type="button" class="grd-icon-btn" *ngIf="d.justificante"
                  [disabled]="descargando"
                  (click)="descargar(d.justificante, 'justificante.pdf')"
                  [matTooltip]="'REMESAS.DETAIL.DESCARGAR_JUST' | translate"
                  matTooltipClass="em-tooltip"
                  matTooltipPosition="left" [attr.aria-label]="'REMESAS.DETAIL.DESCARGAR_JUST' | translate">
            <mat-icon>verified</mat-icon>
          </button>
        </div>
      </div>
      <div *ngIf="data.comunicacion.destinatarios.length === 0" class="grd-empty-text">
        {{ 'REMESAS.DETAIL.SIN_DESTINATARIOS' | translate }}
      </div>
    </div>
  </div>

  <div class="grd-drawer__footer">
    <button type="button" class="grd-btn grd-btn--ghost-sm" *ngIf="!isPendienteFirma()" (click)="emit('duplicate')">
      <mat-icon>content_copy</mat-icon> {{ 'REMESAS.DETAIL.DUPLICAR' | translate }}
    </button>
    <button type="button" class="grd-btn grd-btn--danger-sm" *ngIf="isBorrador() || isPendienteFirma()" (click)="emit('delete')">
      <mat-icon>delete</mat-icon> {{ 'REMESAS.DETAIL.ELIMINAR' | translate }}
    </button>
    <button type="button" class="grd-btn grd-btn--primary-sm" *ngIf="isBorrador()" (click)="emit('edit')">
      <mat-icon>edit</mat-icon> {{ 'REMESAS.DETAIL.EDITAR' | translate }}
    </button>
    <button type="button" class="grd-btn grd-btn--primary-sm" *ngIf="isPendienteFirma() && esNotificacion()" (click)="emit('firmar-enviar')">
      <mat-icon>draw</mat-icon> {{ 'REMESAS.DETAIL.FIRMAR_ENVIAR' | translate }}
    </button>
  </div>
</div>
